<template>
  <a :href="link">
    <img :src="image" :alt="alt">
    <font-awesome-icon v-if="!loaded" icon="spinner" spin size="lg"></font-awesome-icon>
  </a>
</template>

<script>
export default {
  props: {
    src: {
      type: [String],
      required: true
    },
    thumb: {
      type: [String],
      default: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    },
    alt: {
      type: [String],
      default: 'Slika izdelka'
    },
    link: {
      type: [String],
      default: '#product-link'
    }
  },

  data () {
    return {
      loaded: false,
      image: this.thumb
    }
  },

  created () {
    let image = document.createElement('img')
    image.onload = () => {
      this.loaded = true
      this.image = this.src
    }
    image.src = this.src
  }
}
</script>

<style lang="scss" scoped>
  a {
    position: relative;

    svg {
      position: absolute;
      top: 45%;
      left: 45%;
    }
  }
</style>
